/**
 * For details see
 * https://developer.twitter.com/en/docs/twitter-for-websites/cards/overview/markup
 */
export type TTwitterMeta = {
    card: TwitterCardType;
} & ITwitterCommonCardMeta &
    ITwitterPlayerCardMeta &
    ITwitterAppCardMeta;

/**
 * For details see
 * https://developer.twitter.com/en/docs/twitter-for-websites/cards/overview/abouts-cards
 */
export enum TwitterCardType {
    SummaryLargeImage = 'summary_large_image',
    Summary = 'summary',
    Player = 'player',
    App = 'app',
}

export interface ITwitterCommonCardMeta {
    /**
     * @username of website. Either twitter:site or twitter:site:id is required.
     * Used with all types of cards
     **/
    site?: string;

    /**
     * Same as twitter:site, but the user’s Twitter ID. Either twitter:site or twitter:site:id is required.
     * Used with all types of cards
     **/
    siteId?: string;

    /**
     * Same as twitter:site, but the user’s Twitter ID. Either twitter:site or twitter:site:id is required.
     * Used with summary_large_image cards
     **/
    creator?: string;

    /**
     * Twitter user ID of content creator
     * Used with summary, summary_large_image cards
     */
    creatorId?: string;

    /**
     * Description of content (maximum 200 characters)
     * Used with all types of cards
     */
    description?: string;

    /**
     * Title of content (max 70 characters)
     * Used with summary, summary_large_image, player cards
     */
    title?: string;

    /**
     * URL of image to use in the card.
     * Used with summary, summary_large_image, player cards
     */
    image?: string;

    /**
     * A text description of the image. Maximum 420 characters.
     * Used with summary, summary_large_image, player cards
     */
    imageAlt?: string;
}

/** For details see https://developer.twitter.com/en/docs/twitter-for-websites/cards/overview/player-card **/
export interface ITwitterPlayerCardMeta {
    player?: string;
    playerWidth?: number;
    playerHeight?: number;
    playerStream?: string;
}

/** For details see https://developer.twitter.com/en/docs/twitter-for-websites/cards/overview/app-card **/
export interface ITwitterAppCardMeta {
    appNameIphone?: string;
    appIdIphone?: string;
    appUrlIphone?: string;
    appNameIpad?: string;
    appIdIpad?: string;
    appUrlIpad?: string;
    appNameGoogleplay?: string;
    appIdGoogleplay?: string;
    appUrlGoogleplay?: string;
}
